/* import __COLOCATED_TEMPLATE__ from './verify.hbs'; */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';
import styles from './verify.module.scss';

@classic
@classNames(styles.component)
export default class SignInPinVerify extends Component {}
